import api from '@/api_alv'
import Vue from 'vue'
import i18n from '@/assets/i18n/i18n'
import { router } from '@/router.js'

const DIR = 'label/salesdata'

const lastDayOfMonth = month => {
    if (!month) return null
    const [year, monthNumber] = month.split('-').map(Number)
    return new Date(Date.UTC(year, monthNumber, 0)).toISOString().slice(0, 10)
}

const DEFAULT_INLINE_EDITING_VALUES = {
    showConversionFactor: true,
    conversionFactor: null,
    commissionPercent: null,
    period: {
        num: null,
        period: "notDefined",
        year: null
    }
}

const state = {
// List
    salesData: [],
    selectedSalesData: [],
    isAllSelectedSalesData: false,
    expandedSalesData: [],
    salesDataInlineEditingDialogDetails: {},
    salesDataInlineEditingDialogDefault: DEFAULT_INLINE_EDITING_VALUES,
    salesDataServerSideSortingOptions:{
        sortBy: ['importDate'],
        sortDesc: [true],
        mustSort: true
    },

// Filters
    salesDataSearch: '',
    selectedSalesDataHalfYearFilter: null,

// Actions (Buttons, Imports, Exports)
    selectedSalesDataAction: "",
    labelSalesDataImportOptions: [],

//Actions:Move
    labelSalesDataDetailsSelectedCompany:[],

    // Import 
    selectedImportSalesDataCheckbox: ['runErrorLists'],
    labelSalesDataDetailsImportCurrencyConversionFactor: null,
    labelSalesDataDetailsImportAbbreviation: [],
    labelSalesDataDetailsAlvIdOfSource: null,
    labelSalesDataDetailsFileExtensions: null,
    selectedPeriodValues: {
        number: null,
        timeUnit: 'notDefined',
        year: null
    },
    labelSalesDataDetailsImportCommissionPercent: null,

// Details
    salesDataDetails: {},

// GEMA TAS 2026 Dialog
    showGemaTas2026Dialog: false,
    gemaTas2026DialogDetailsFromDate: null,
    gemaTas2026DialogDetailsToDate: null,
    gemaTas2026DialogDetailsHapMode: 'average',
    gemaTas2026DialogDetailsPriceType: 'HAP',
    gemaTas2026DialogDetailsPauschalretouren: 8,
    gemaTas2026DialogDetailsExcludedCountries: 'US, CA',
    gemaTas2026DialogReportLink: null,
    gemaTas2026DialogReportStamp: null,
    gemaTas2026DialogAiAnalysisLink: null,
    gemaTas2026DialogIsAnalyzing: false
}

const getters = {
// List
    getSalesData(state) { return state.salesData },
    getSelectedSalesData(state) { return state.selectedSalesData },
    getIsAllSelectedSalesData(state) { return state.isAllSelectedSalesData },
    getExpandedSalesData(state) { return state.expandedSalesData },
    getSalesDataServerSideSortingOptions(state){ return state.salesDataServerSideSortingOptions },

    // Inline Editing Dialog
    getSalesDataInlineEditingDialogDefault                  (state) { return state.salesDataInlineEditingDialogDefault },
    getSalesDataInlineEditingDialogDetails                  (state) { return state.salesDataInlineEditingDialogDetails },
    getSalesDataInlineEditingDialogDetailsConversionFactor  (state) { return state.salesDataInlineEditingDialogDetails.conversionFactor },
    getSalesDataInlineEditingDialogDetailsCommissionPercent (state) { return state.salesDataInlineEditingDialogDetails.commissionPercent },
    
    // Period
    getSelectedPeriodValuesSalesDataInlineEditingDialog(state) { return state.salesDataInlineEditingDialogDetails.period },
    getSelectedPeriodNumberSalesDataInlineEditingDialog(state) { return state.salesDataInlineEditingDialogDetails.period.num },
    getSelectedPeriodTimeUnitSalesDataInlineEditingDialog(state) { return state.salesDataInlineEditingDialogDetails.period.period },
    getSelectedPeriodYearSalesDataInlineEditingDialog(state) { return state.salesDataInlineEditingDialogDetails.period.year },


// Filters
    getSalesDataSearch(state) { return state.salesDataSearch },
    getSelectedSalesDataHalfYearFilter(state) { return state.selectedSalesDataHalfYearFilter },

// Actions (Buttons, Imports, Exports)
    getSelectedSalesDataAction(state) { return state.selectedSalesDataAction },
    getSalesDataImportOptions(state) { return state.labelSalesDataImportOptions },

//Actions:Move
    getLabelSalesDataDetailsSelectedCompany(state) { return state.labelSalesDataDetailsSelectedCompany },
    
    // Import
    getSelectedImportSalesDataCheckbox                  (state) { return state.selectedImportSalesDataCheckbox },
    getSalesDataDetailsImportCurrencyConversionFactor   (state) { return state.labelSalesDataDetailsImportCurrencyConversionFactor },
    getSalesDataDetailsAbbreviation                     (state) { return state.labelSalesDataDetailsImportAbbreviation },
    getSalesDataDetailsAlvIdOfSource                    (state) { return state.labelSalesDataDetailsAlvIdOfSource },
    getSalesDataDetailsFileExtensions                   (state) { return state.labelSalesDataDetailsFileExtensions },
    getSalesDataDetailsImportCommissionPercent          (state) { return state.labelSalesDataDetailsImportCommissionPercent },

    // Period
    getSelectedPeriodValuesSalesdata(state) { return state.selectedPeriodValues },
    getSelectedPeriodNumberSalesdata (state) { return state.selectedPeriodValues.num },
    getSelectedPeriodTimeUnitSalesdata(state) { return state.selectedPeriodValues.period },
    getSelectedPeriodYearSalesdata(state) { return state.selectedPeriodValues.year },

// Details
    getSalesDataDetails(state) { return state.salesDataDetails },

// GEMA TAS 2026 Dialog
    getShowGemaTas2026Dialog(state)                          { return state.showGemaTas2026Dialog },
    getGemaTas2026DialogDetailsFromDate(state)               { return state.gemaTas2026DialogDetailsFromDate },
    getGemaTas2026DialogDetailsToDate(state)                 { return state.gemaTas2026DialogDetailsToDate },
    getGemaTas2026DialogDetailsHapMode(state)                { return state.gemaTas2026DialogDetailsHapMode },
    getGemaTas2026DialogDetailsPriceType(state)              { return state.gemaTas2026DialogDetailsPriceType },
    getGemaTas2026DialogDetailsPauschalretouren(state)       { return state.gemaTas2026DialogDetailsPauschalretouren },
    getGemaTas2026DialogDetailsExcludedCountries(state)      { return state.gemaTas2026DialogDetailsExcludedCountries },
    getGemaTas2026DialogReportLink(state)                    { return state.gemaTas2026DialogReportLink },
    getGemaTas2026DialogReportStamp(state)                   { return state.gemaTas2026DialogReportStamp },
    getGemaTas2026DialogAiAnalysisLink(state)                { return state.gemaTas2026DialogAiAnalysisLink },
    getGemaTas2026DialogIsAnalyzing(state)                   { return state.gemaTas2026DialogIsAnalyzing },
}

const mutations = {
// List
    setSalesData:                                               (state, salesDataFromDB) => { state.salesData = salesDataFromDB },
    setSelectedSalesData:                                       (state, selectedSalesData) => { state.selectedSalesData = selectedSalesData },
    setIsAllSelectedSalesData:                                  (state, isSelected) => { state.isAllSelectedSalesData = isSelected },
    setExpandedSalesData:                                       (state, salesdata) => {
                                                                    if(Object.keys(salesdata).length === 0) state.expandedSalesData = []
                                                                    else state.expandedSalesData.push(salesdata)
                                                                },
    setSalesDataServerSideSortingOptions:                       (state, value) => { state.salesDataServerSideSortingOptions = value },

    // Inline Editing Dialog
    setSalesDataInlineEditingDialogDefault:                     (state) => { state.salesDataInlineEditingDialogDefault = DEFAULT_INLINE_EDITING_VALUES },
    setSalesDataInlineEditingDialogDetails:                     (state, details) => { state.salesDataInlineEditingDialogDetails = details },
    setSalesDataInlineEditingDialogDetailsConversionFactor:     (state, factor) => { state.salesDataInlineEditingDialogDetails.conversionFactor = factor },
    setSalesDataInlineEditingDialogDetailsCommissionPercent:    (state, value)  => { state.salesDataInlineEditingDialogDetails.commissionPercent = value},
    // Period
    setSelectedPeriodValuesSalesDataInlineEditingDialog:        (state, values) => { state.salesDataInlineEditingDialogDetails.period = values },
    setSelectedPeriodNumberSalesDataInlineEditingDialog:        (state, number) => { state.salesDataInlineEditingDialogDetails.period.num =  number },
    setSelectedPeriodTimeUnitSalesDataInlineEditingDialog:      (state, unit) => { state.salesDataInlineEditingDialogDetails.period.period = unit },
    setSelectedPeriodYearSalesDataInlineEditingDialog:          (state, year) => { state.salesDataInlineEditingDialogDetails.period.year = year },

// Filters
    setSalesDataSearch: (state, search) => { state.salesDataSearch = search },
    setSelectedSalesDataHalfYearFilter: (state, halfYear) => { state.selectedSalesDataHalfYearFilter = halfYear },

// Actions (Buttons, Imports, Exports)
    setSelectedSalesDataAction: (state, action) => { state.selectedSalesDataAction = action },
    setSalesDataImportOptions:                                  (state, value) => { state.labelSalesDataImportOptions = value },

    //Actions: Move
    setLabelSalesDataDetailsSelectedCompany: (state, selected) => { state.labelSalesDataDetailsSelectedCompany = selected },
    
    // Import
    setSelectedImportSalesDataCheckbox:                     (state, selected) => { state.selectedImportSalesDataCheckbox = selected },
    setSalesDataDetailsImportCurrencyConversionFactor:      (state, factor) => { state.labelSalesDataDetailsImportCurrencyConversionFactor = factor },
    setSalesDataDetailsAbbreviation:                        (state, factor) => { state.labelSalesDataDetailsImportAbbreviation = factor },
    setSalesDataDetailsAlvIdOfSource:                       (state, value) => { state.labelSalesDataDetailsAlvIdOfSource = value },
    setSalesDataDetailsFileExtensions:                      (state, value) => { state.labelSalesDataDetailsFileExtensions = value },
    setSalesDataDetailsImportCommissionPercent:             (state, value) => { state.labelSalesDataDetailsImportCommissionPercent = value },

    // Period
    setSelectedPeriodValues: (state, selectedValues) => { state.selectedPeriodValues = selectedValues },
    setSelectedPeriodNumberSalesdata: (state, newNumber) => { state.selectedPeriodValues.num = newNumber },
    setSelectedPeriodTimeUnitSalesdata: (state, newValue) => { state.selectedPeriodValues.period = newValue },
    setSelectedPeriodYearSalesdata: (state, newYear) => { state.selectedPeriodValues.year = newYear },

    // Details 
    setSalesDataDetails:                                (state, details) => { state.salesDataDetails = details },

// GEMA TAS 2026 Dialog
    setShowGemaTas2026Dialog:                          (state, val) => { state.showGemaTas2026Dialog = val },
    setGemaTas2026DialogDetailsFromDate:               (state, val) => { state.gemaTas2026DialogDetailsFromDate = val },
    setGemaTas2026DialogDetailsToDate:                 (state, val) => { state.gemaTas2026DialogDetailsToDate = val },
    setGemaTas2026DialogDetailsHapMode:                (state, val) => { state.gemaTas2026DialogDetailsHapMode = val },
    setGemaTas2026DialogDetailsPriceType:              (state, val) => { state.gemaTas2026DialogDetailsPriceType = val },
    setGemaTas2026DialogDetailsPauschalretouren:       (state, val) => { state.gemaTas2026DialogDetailsPauschalretouren = val },
    setGemaTas2026DialogDetailsExcludedCountries:      (state, val) => { state.gemaTas2026DialogDetailsExcludedCountries = val },
    setGemaTas2026DialogReportLink:                    (state, val) => { state.gemaTas2026DialogReportLink = val },
    setGemaTas2026DialogReportStamp:                   (state, val) => { state.gemaTas2026DialogReportStamp = val },
    setGemaTas2026DialogAiAnalysisLink:                (state, val) => { state.gemaTas2026DialogAiAnalysisLink = val },
    setGemaTas2026DialogIsAnalyzing:                   (state, val) => { state.gemaTas2026DialogIsAnalyzing = val },
}

const actions = {
// LIST PAGE
    async fetchSalesData({ commit, getters }) {
        commit('setIsLoading', true)

        const selectedHalfYear = getters.getSelectedSalesDataHalfYearFilter
        const [year, halfYear] = typeof selectedHalfYear === 'string' ? selectedHalfYear.split('-') : [null, null]
        
        // check for set filters
        let filterObj = {
            'search' :  getters.getSalesDataSearch,
            'year' : year,
            'halfYear' : halfYear,
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // Get list items from db
        // let response = await api.getListData(DIR, getters.getCurrentPage, paramsString) 
        let options = getters.getSalesDataServerSideSortingOptions
        let response = await api.getListData2(DIR, getters.getCurrentPage, options.sortBy, options.sortDesc, paramsString)  
        
        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setSalesData', [])
        } else {
            commit('setSalesData', response.list)
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)
    },

// DETAILS  
    async fetchSalesDataDetails({ commit }, alvId) {
        let response = await api.getDetailsById(DIR, alvId, '/errorList')

        if(response.list.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        commit('setSalesDataDetails', response)
        commit('setIsLoading', false)
    },

// IMPORTERS  
    async fetchSalesDataImporters({ commit }, alvId) {
        let response = await api.getImporters('label/salesdata')
        commit('setSalesDataImportOptions', response)
    },

// SAVE Edit row (Listpage)
    async saveSalesDataEditDialog({ getters, commit, dispatch }) {
        commit('setIsLoading', true)
        let alvId = getters.getSelectedSalesData
        let metaData = {
            "period"            :   getters.getSelectedPeriodValuesSalesDataInlineEditingDialog,
            "conversionFactor"  :   getters.getSalesDataInlineEditingDialogDetailsConversionFactor,
            "commissionPercent"  :   getters.getSalesDataInlineEditingDialogDetailsCommissionPercent
        }

        let response = await api.saveEditForm(DIR, alvId, metaData)
        if(response.error === -1) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_LABEL_SALES_DATA_SUCCESS_SAVED')
            })
            dispatch('fetchSalesData')
        } else {
            let errorMsg = response.response.errorMsg
            commit('setSnackbar', { 
                type: 'error', 
                msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
            })
        }
    },

    // ACTIONS
    async doSalesDataAction({ commit, dispatch, getters }) {
        let salesFileIds = { 'salesFileIds': getters.getSelectedSalesData }
        switch(state.selectedSalesDataAction) {
            case 'runErrorLists': 
                if(state.selectedSalesData.length > 0) {
                    // call general function in actions.js
                    dispatch('runErrorLists', { dir: DIR, metaData: salesFileIds, context: "SalesData"})
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }
                break
            case 'downloadErrorList': 
                if(state.selectedSalesData.length > 0) {
                    // call general function in actions.js
                    dispatch('downloadErrorLists', { dir: DIR, metaData: salesFileIds })
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }
                break
            case 'createFromSalesData':
                if(state.selectedSalesData.length === 1) {
                    dispatch('createFromSalesData')
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }
                break
            case 'delete':
                if(state.selectedSalesData.length > 0) {
                    commit('setShowDeletionDialog', true)
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                    commit('setShowSelectionRequiredDialog', true)	
                }
                break
            case 'move':
                if(state.selectedSalesData.length > 0) {
                    commit('setShowMoveContractsDialog',true)
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                    commit('setShowSelectionRequiredDialog', true)	
                }
                break
            }
    },

    // Action: Create Invoice From Sales Data file
    async createFromSalesData({ getters, commit, dispatch }) {
        let selectedSalesDataAlvId = getters.getSelectedSalesData
        let listOfRows = getters.getSalesData
        
        let match = listOfRows.find(element=>{
            return element.alvId === selectedSalesDataAlvId[0]
        })

        if(match.records > 900){
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ABOVE_900_RECORDS'),
            })
        }else{
                commit('setIsLoading', true)
                let metaData = {}
                metaData["alvIds"] = selectedSalesDataAlvId
                let queryParams = {
                    "action" : "createInvoiceFromSalesData" // change name
                }
                
                let response = await api.triggerAction(DIR, metaData, queryParams)
                if(response.error === -1) {
                    // Change selected overall company, so when redirected to the edit form of the new created invoice, 
                    // the selected company in erp > invoice is the correct label company
                    let selectedCompany = getters.getLabelCompanies.find(company =>
                        company.id === getters.getSelectedLabelCompanyId
                    )

                    commit('setSelectedOverAllCompany', selectedCompany)
                    dispatch('changeCompany')

                    router.push( { name: 'InvoicesEdit', params: { alvId: response.response.alvId} })
                    commit('setSnackbar', {
                        type: 'success',
                        msg: i18n.t('lang_GENERIC_SNACKBAR_SAVING_SUCCESSFUL'),
                    })
                } else {
                    commit('setSnackbar', {
                        type: 'error',
                        msg: i18n.t(response.response.errorMsg),
                    })
                }
                commit('setIsLoading', false)
            }
    },


    // Action: DELETE
    async deleteSelectedSalesData({ commit, getters, dispatch }) {
        const response = await api.deleteEntries(DIR, getters.getSelectedSalesData)
        if(response.error === -1) {        
            for(let i = 0; i < getters.getSelectedSalesData.length; i++) {
                let index = getters.getSalesData.findIndex(release => release.alvId == getters.getSelectedSalesData[i])
                Vue.delete(getters.getSalesData, index)
            }
            
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_DELETED')
            })
            
            commit('setSelectedSalesData', [])
            commit('setSelectedSalesDataAction', [])
            dispatch('fetchSalesData')
        }
    },

    // Action: GEMA TAS 2026 Report
    async createLabelGemaTas2026Report({ commit, getters }) {
        commit('setIsLoading', true)
        commit('setGemaTas2026DialogReportLink', null)
        commit('setGemaTas2026DialogReportStamp', null)
        commit('setGemaTas2026DialogAiAnalysisLink', null)

        const fromMonth = getters.getGemaTas2026DialogDetailsFromDate // 'YYYY-MM'
        const toMonth   = getters.getGemaTas2026DialogDetailsToDate

        const fromDate = fromMonth ? fromMonth + '-01' : null
        const toDate = lastDayOfMonth(toMonth)

        const excludedRaw = (getters.getGemaTas2026DialogDetailsExcludedCountries || '').toString()
        const excludedCountries = excludedRaw
            .split(/[,;\s]+/)
            .map(c => c.trim().toUpperCase())
            .filter(c => c.length > 0)

        const body = {
            fromDate,
            toDate,
            hapMode:           getters.getGemaTas2026DialogDetailsHapMode,
            priceType:         getters.getGemaTas2026DialogDetailsPriceType,
            pauschalretouren:  Number(getters.getGemaTas2026DialogDetailsPauschalretouren) / 100,
            excludedCountries,
        }

        const response = await api.triggerAction('label/salesdata/gematas2026', body, {})

        if (response && response.error === -1) {
            commit('setGemaTas2026DialogReportLink', response.response.path)
            commit('setGemaTas2026DialogReportStamp', response.response.stamp || null)
            commit('setSnackbar', { type: 'success', msg: i18n.t('lang_GENERIC_MESSAGE_SUCCESS_PROCESS_COMPLETED') })
        } else {
            commit('setSnackbar', { type: 'error', msg: i18n.t('lang_GENERIC_SNACKBAR_DOWNLOAD_NOT_SUCCESSFULL') })
        }

        commit('setIsLoading', false)
    },

    // Action: GEMA TAS 2026 — AI Anomaly Analysis
    async analyzeLabelGemaTas2026Report({ commit, getters }) {
        const stamp = getters.getGemaTas2026DialogReportStamp
        if (!stamp) {
            commit('setSnackbar', { type: 'error', msg: i18n.t('lang_GENERIC_SNACKBAR_DOWNLOAD_NOT_SUCCESSFULL') })
            return
        }

        commit('setGemaTas2026DialogIsAnalyzing', true)
        commit('setGemaTas2026DialogAiAnalysisLink', null)

        const fromMonth = getters.getGemaTas2026DialogDetailsFromDate
        const toMonth   = getters.getGemaTas2026DialogDetailsToDate

        const fromDate = fromMonth ? fromMonth + '-01' : null
        const toDate = lastDayOfMonth(toMonth)

        const excludedRaw = (getters.getGemaTas2026DialogDetailsExcludedCountries || '').toString()
        const excludedCountries = excludedRaw
            .split(/[,;\s]+/)
            .map(c => c.trim().toUpperCase())
            .filter(c => c.length > 0)

        const body = {
            stamp,
            fromDate,
            toDate,
            hapMode:           getters.getGemaTas2026DialogDetailsHapMode,
            priceType:         getters.getGemaTas2026DialogDetailsPriceType,
            pauschalretouren:  Number(getters.getGemaTas2026DialogDetailsPauschalretouren) / 100,
            excludedCountries,
        }

        const response = await api.triggerAction('label/salesdata/gematas2026/aianalyze', body, {})

        if (response && response.error === -1) {
            commit('setGemaTas2026DialogAiAnalysisLink', response.response.path)
            commit('setSnackbar', { type: 'success', msg: i18n.t('lang_GENERIC_MESSAGE_SUCCESS_PROCESS_COMPLETED') })
        } else {
            commit('setSnackbar', { type: 'error', msg: i18n.t('lang_GENERIC_SNACKBAR_DOWNLOAD_NOT_SUCCESSFULL') })
        }

        commit('setGemaTas2026DialogIsAnalyzing', false)
    },

    //ACtion : MOVE
    async moveSelectedLabelSalesData({ getters, commit, dispatch  }) {

        let metaData = { "alvIds" : getters.getSelectedSalesData,
        
                         "company" : getters.getLabelSalesDataDetailsSelectedCompany }
        let queryParams = { "action": 'move'}
        const response = await api.triggerAction(DIR,metaData,queryParams)


        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_MOVED')
            })
        }
        
        commit('setSelectedSalesData', [])
        commit("setIsAllSelectedSalesData",false)
        commit('setSelectedSalesDataAction', [])
        dispatch('fetchSalesData')
    },
}

export default {
    state, getters, actions, mutations
}
